<template>
  <div ref="myEcharts" :style="{ height, width }"></div>
</template>
<script setup >
// props="['width','height','right1Data']"
import { ref, onMounted,defineProps,watchEffect } from "vue";
import * as echarts from "echarts";
const props =defineProps({
  width: {
    type: String,
    default: "100%",
  },
  height: {
    type: String,
    default: "100%",
  },
  listData: {
    type: Array,
    default: () => [],
  },
})
// console.log(props.leftData2);
const myEcharts = ref(null);

onMounted(() => {

  initChart(props.listData);
});


function initChart(listData) {
  if (myEcharts.value && myEcharts.value.chart) {
    myEcharts.value.chart.dispose();
  }

  const chartInstance = echarts.init(myEcharts.value);


let formatNumber = function(num) {
    let reg = /(?=(\B)(\d{3})+$)/g;
    return num.toString().replace(reg, ',');
}
var echartData = [
      {
      name: "绞盘式喷灌",
      value: 29500
    },
    {
          name: "平固定式喷灌移喷灌",
          value: 900
      },
      {
          name: "半固定式喷灌",
          value: 9000
      },
      {
          name: "平移式喷灌",
          value: 750
      },
      {
          name: "微灌式喷灌",
          value: 9850
      },
    ]
  const option= {
      tooltip: {
        trigger: 'item',
        formatter: '{b}:({d}%)',
      },
      title: {
          text: "     总数",
          subtext: echartData && echartData.reduce((prev, cur) => {
            // let total=
            return prev + cur.value;
          }, 0),
          textStyle: {
            color: "#FFF",
            fontSize:30,
            align: "center",

          },
          subtextStyle: {
            fontSize: 50,
            color: "#FFF",
            align: "center",
          },
          x: "43%",
          y: "41%",
      },
          grid: {
            containLabel: true,
          },
          series: [
            {
              type: 'pie',
              radius: ['40%', '70%'],
              center: ['51%', '50%'],
              color: ['#F3BB8A','#36BB98','#697CF5','#57E5F7','#409EF6'],
             label: {
            normal: {
                formatter: params => {
                    return (
                        '{icon|●}{name|' + params.name + '}\n{value|' +
                        params.value + '亩}'
                        // formatNumber(params.value) + '亩}'
                    );
                },
                // padding: [0 , -100, 25, -100],
                rich: {
                    icon: {
                        fontSize: 30,
                        color: 'inherit'
                    },
                    name: {
                        fontSize:30,
                        padding: [0, 0, 0, 5],
                        color: '#fff'
                    },
                    value: {
                        fontSize: 30,
                        fontWeight: 'bolder',
                        padding: [10, 0, 0, 20],
                        color: 'inherit'
                        // color: '#333333'
                    }
                }
            }
        },
              labelLine: {
                show: true,
                length2: 10,
                length: 10,
              },
              data:echartData ,
            },
          ],
  };// 将你的ECharts配置项放在这里
  chartInstance.setOption(option);

}
window.addEventListener("resize", () => {
  chartInstance.resize();
});
function splitArray(array, size) {
  var result = Array.from({ length: Math.ceil(array.length / size) }, function(_, index) {
    return array.slice(index * size, index * size + size);
  });
  return result;
}
</script>
<style lang="less"></style>
